import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10;
import { __rest as e } from "../../_virtual/_tslib.js";
import { jsx as t, jsxs as r } from "react/jsx-runtime";
import { calculateRem as n, withVDSManager as a, getOS as o, getBrowser as i, checkIfMobileDevice as s, generateUUID as d } from "@vds-core/utilities";
import { Component as l } from "react";
import { AccessibilityTokens as u } from "@vds-tokens/accessibility";
import { ColorTokens as c } from "@vds-tokens/color";
import { Fonts as p } from "@vds-core/typography";
import { FormControlsTokens as h } from "@vds-tokens/form-controls";
import { LayoutTokens as v } from "@vds-tokens/layout";
import { TextLink as f } from "@vds-core/buttons";
import { TypographyTokens as m } from "@vds-tokens/typography";
import y from "styled-components";
import { showError as b, HelperText as g, Label as k, ErrorText as $ } from "@vds-core/form-elements";
import C from "./assets/CreditCardIcon.js";
import { _onlyNumbers as w, _ignoreAlpha as x, dateOnChange as T, _formatToPhoneDash as I, creditCardOnChange as S, _maskValue as _, stickyPlaceholderHTML as P, _formatOnLoad as B, _determineCard as L, determineMaxLength as A } from "./util/InputFormatting.js";
var E = t("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.6 21.6",
    children: t("path", {
      d: "M10.80213,19.80122a2.39567,2.39567,0,0,1-1.705-.707L2.50743,12.50444a2.41244,2.41244,0,0,1,0-3.40913L9.09808,2.50555a2.4159,2.4159,0,0,1,3.40908-.001l6.58967,6.59073a2.41244,2.41244,0,0,1,0,3.40913L12.50716,19.0942A2.394,2.394,0,0,1,10.80213,19.80122Zm-7.4998-9.911a1.289,1.289,0,0,0,0,1.81931L9.893,18.29929a1.31476,1.31476,0,0,0,1.81928,0l6.58967-6.58976a1.289,1.289,0,0,0,0-1.81931L11.71226,3.30047a1.29076,1.29076,0,0,0-1.81928,0ZM9.95,15.05h1.7V13.367H9.95Zm0-6.00953.561,2.635h.56952l.56951-2.635V6.55H9.95Z"
    })
  }),
  D = t("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.6 21.6",
    children: t("path", {
      d: "M10.80009,19.80015a9,9,0,1,1,9-9A9.01054,9.01054,0,0,1,10.80009,19.80015Zm0-16.87512a7.87512,7.87512,0,1,0,7.87512,7.87512A7.88411,7.88411,0,0,0,10.80009,2.925ZM14.75,8.63964,13.95474,7.85,9.62367,12.17072,7.64331,10.20631,6.85,10.9979,9.62562,13.75Z"
    })
  });
var V = {
    password: 62,
    inlineAction: 102,
    creditCard: 288,
    tel: 176,
    securityCode: 88,
    date: 114
  },
  O = y.div.withConfig({
    displayName: "ComponentContainer",
    componentId: "VDS__sc-1nnt7hu-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  width: ", ";\n  min-width: ", ";\n"])), function (_ref) {
    var e = _ref.$helperTextPlacement;
    return "right" === e ? "row" : "column";
  }, function (_ref2) {
    var e = _ref2.$containerWidth;
    return "number" == typeof e ? n(e) : e;
  }, function (_ref3) {
    var e = _ref3.$minWidth;
    return n(e);
  }),
  F = y.div.withConfig({
    displayName: "StyledContainer",
    componentId: "VDS__sc-1nnt7hu-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  position: relative;\n  flex-direction: column;\n  input[type='number'] {\n    -moz-appearance: textfield; /* Firefox */\n  }\n"]))),
  W = y.span.withConfig({
    displayName: "InputContainer",
    componentId: "VDS__sc-1nnt7hu-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  justify-content: space-between;\n  height: ", ";\n  min-width: ", ";\n  background-color: ", ";\n  box-sizing: border-box;\n  border-radius: ", ";\n  border: ", " solid\n    ", ";\n  border-bottom: ", " solid\n    ", ";\n  ", ";\n\n  ", ";\n  ", "\n"])), function (_ref4) {
    var e = _ref4.$inputHeight;
    return e;
  }, function (_ref5) {
    var e = _ref5.$minWidth;
    return n(e);
  }, function (_ref6) {
    var e = _ref6.surface,
      t = _ref6.$transparentBackground,
      r = _ref6.$error,
      n = _ref6.$success,
      a = _ref6.disabled;
    return !t || r || n ? function (e) {
      var t = e.$error,
        r = e.surface,
        n = e.disabled,
        a = e.$success;
      return t && "dark" === r && !n ? c.feedback.error.background.ondark.value : t && "dark" !== r && !n ? c.feedback.error.background.onlight.value : a && "dark" !== r && !n ? c.feedback.success.background.onlight.value : a && "dark" === r && !n ? c.feedback.success.background.ondark.value : "dark" === r ? h.color.background.ondark.value : h.color.background.onlight.value;
    }({
      $error: r,
      surface: e,
      disabled: a,
      $success: n
    }) : "transparent";
  }, h.border.radius.value, n(h.border.width.value), function (_ref7) {
    var e = _ref7.$error,
      t = _ref7.$isOpen,
      r = _ref7.disabled,
      n = _ref7.$focused,
      a = _ref7.surface,
      o = _ref7.$success,
      i = _ref7.$hovered;
    return function (e, t, r, n, a, o, i) {
      return e && "dark" !== t ? c.interactive.disabled.onlight.value : e && "dark" === t ? c.interactive.disabled.ondark.value : (i || a || o) && "dark" !== t && !e ? c.elements.primary.onlight.value : (i || a || o) && "dark" === t && !e ? c.elements.primary.ondark.value : r && !e && "dark" !== t ? c.feedback.error.onlight.value : r && !e && "dark" === t ? c.feedback.error.ondark.value : n && !e && "dark" !== t ? c.feedback.success.onlight.value : n && !e && "dark" === t ? c.feedback.success.ondark.value : "dark" === t ? h.color.border.ondark.value : h.color.border.onlight.value;
    }(r, a, e, o, n, i, t);
  }, n(1), function (_ref8) {
    var e = _ref8.disabled,
      t = _ref8.surface,
      r = _ref8.$error,
      n = _ref8.$success,
      a = _ref8.$focused,
      o = _ref8.$hovered,
      i = _ref8.$isOpen;
    return function (e, t, r, n, a, o, i) {
      return e && "dark" !== t ? c.interactive.disabled.onlight.value : e && "dark" === t ? c.interactive.disabled.ondark.value : !r || "dark" === t || a || o || i ? !r || "dark" !== t || a || o || i ? !n || "dark" === t || a || o ? !n || "dark" !== t || a || o ? i || a || o || "dark" !== t || e ? i || a || o || "dark" === t || e ? "dark" === t ? c.elements.primary.ondark.value : c.elements.primary.onlight.value : c.elements.secondary.onlight.value : c.elements.secondary.ondark.value : c.feedback.success.ondark.value : c.feedback.success.onlight.value : c.feedback.error.ondark.value : c.feedback.error.onlight.value;
    }(e, t, r, n, a, o, i);
  }, function (_ref9) {
    var e = _ref9.readOnly,
      t = _ref9.surface;
    return e && "\n      border: ".concat(n(1), " solid ").concat("dark" === t ? h.color.border.readonly.ondark.value : h.color.border.readonly.onlight.value, ";\n  ");
  }, function (_ref0) {
    var e = _ref0.readOnly,
      t = _ref0.disabled,
      r = _ref0.surface;
    return "\n      &:hover {\n        border: ".concat(n(1), " solid ").concat((e || t) && "dark" !== r ? c.interactive.disabled.onlight.value : (e || t) && "dark" === r ? c.interactive.disabled.ondark.value : "dark" === r ? h.color.border.hover.ondark.value : h.color.border.hover.onlight.value, ";\n\n  }\n  ");
  }, function (_ref1) {
    var e = _ref1.disabled,
      t = _ref1.surface,
      r = _ref1.$focused,
      a = _ref1.$keyboardFocused;
    return !e && r && a && "\n      outline: none;\n        &::before {\n          border: ".concat(u.focusring.borderwidth.value, " ").concat(u.focusring.borderstyle.value, " ").concat("dark" === t ? u.color.focusring.ondark.value : u.color.focusring.onlight.value, ";\n          content: '';\n          left: 50%;\n          border-radius: ").concat(n(6), ";\n          position: absolute;\n          height: calc(100% + ").concat(n(6), ");\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% + ").concat(n(6), ");\n        }\n      &:hover {\n        &::before {\n          border: none;\n        }\n      }\n    ");
  }),
  q = y.div.withConfig({
    displayName: "StickyPlaceholder",
    componentId: "VDS__sc-1nnt7hu-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  margin-left: ", ";\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n\n  span {\n    color: transparent;\n  }\n  .slash {\n    color: ", ";\n  }\n"])), function (_ref10) {
    var e = _ref10.disabled,
      t = _ref10.surface;
    return e ? c.interactive.disabled.onlight.value : "dark" === t ? c.elements.secondary.ondark.value : c.elements.secondary.onlight.value;
  }, p.VerizonNHGeDS, m.fontsize.body[16].value, m.letterspacing.wide.value, m.lineheight.body[20].value, n(v.space["3X"].value), function (_ref11) {
    var e = _ref11.disabled;
    return e ? c.interactive.disabled.onlight.value : c.elements.primary.onlight.value;
  }),
  z = y.input.withConfig({
    displayName: "StyledInput",
    componentId: "VDS__sc-1nnt7hu-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  width: 100%;\n  border: none;\n  box-sizing: border-box;\n  pointer-events: auto;\n  border-radius: ", ";\n  background-color: transparent;\n  caret-color: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  margin: 0;\n  ::-ms-clear,\n  ::-ms-reveal {\n    display: none;\n  }\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n  }\n  &[disabled] {\n    -webkit-text-fill-color: ", ";\n  }\n\n  ::placeholder {\n    position: relative;\n    color: ", " !important;\n    top: 0px;\n  }\n\n  &:focus {\n    outline: none;\n  }\n  padding: ", ";\n"])), h.border.radius.value, function (_ref12) {
    var e = _ref12.surface,
      t = _ref12.caretColor;
    return t || ("dark" === e ? c.elements.primary.ondark.value : c.elements.primary.onlight.value);
  }, function (_ref13) {
    var e = _ref13.disabled,
      t = _ref13.surface;
    return e && "dark" !== t ? c.interactive.disabled.onlight.value : e && "dark" === t ? c.interactive.disabled.ondark.value : "dark" === t ? c.elements.primary.ondark.value : c.elements.primary.onlight.value;
  }, p.VerizonNHGeDS, n(m.fontsize.body[16].value), n(m.lineheight.body[20].value), function (_ref14) {
    var e = _ref14.$masked;
    return n(e ? v.space["1X"].value : m.letterspacing.wide.value);
  }, function (_ref15) {
    var e = _ref15.surface;
    return "dark" !== e ? c.interactive.disabled.onlight.value : c.interactive.disabled.ondark.value;
  }, function (_ref16) {
    var e = _ref16.surface;
    return "dark" === e ? c.interactive.disabled.ondark.value : c.interactive.disabled.onlight.value;
  }, function (_ref17) {
    var e = _ref17.$calculateInputPadding;
    return e && e();
  }),
  H = y.div.withConfig({
    displayName: "ActionWrapper",
    componentId: "VDS__sc-1nnt7hu-5"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  height: ", ";\n  padding: ", ";\n"])), n(20), n(0, parseInt(h.space.inset.value, 10) - 1, 0, 0)),
  N = y.span.withConfig({
    displayName: "IconContainer",
    componentId: "VDS__sc-1nnt7hu-6"
  })(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  padding-right: ", ";\n  outline: none;\n  pointer-events: none;\n"])), function (_ref18) {
    var e = _ref18.$renderPadding;
    return e && n(v.space["2X"].value);
  }),
  M = y.div.withConfig({
    displayName: "IconSVGWrapper",
    componentId: "VDS__sc-1nnt7hu-7"
  })(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  ", ";\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref19) {
    var e = _ref19.$iconSize;
    return n(e);
  }, function (_ref20) {
    var e = _ref20.$iconSize;
    return n(e);
  }, function (_ref21) {
    var e = _ref21.$iconSize;
    return n(e);
  }, function (_ref22) {
    var e = _ref22.$iconSize;
    return n(e);
  }, function (_ref23) {
    var e = _ref23.tabIndex;
    return e < 0 && "\n    outline: none;\n    pointer-events: none;\n  ";
  }, function (_ref24) {
    var e = _ref24.$iconColor;
    return e;
  }),
  j = y.div.withConfig({
    displayName: "InputWrapper",
    componentId: "VDS__sc-1nnt7hu-8"
  })(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  flex: 1;\n  position: relative;\n  width: 100%;\n"]))),
  Z = y.span.withConfig({
    displayName: "FlexedRowContainer",
    componentId: "VDS__sc-1nnt7hu-9"
  })(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n"]))),
  X = y.span.withConfig({
    displayName: "FlexedColContainer",
    componentId: "VDS__sc-1nnt7hu-10"
  })(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"])), function (_ref25) {
    var e = _ref25.$helperText,
      t = _ref25.$helperTextPlacement;
    return e && "right" === t ? "50%" : "100%";
  }),
  G = y.div.withConfig({
    displayName: "CardIconContainer",
    componentId: "VDS__sc-1nnt7hu-11"
  })(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  padding: ", ";\n  width: ", ";\n  border-radius: 4px 0 0 4px;\n  background-color: transparent;\n"])), n(0, 0, 0, parseInt(h.space.inset.value, 10) - 1), n(34));
var K = /*#__PURE__*/function (_l) {
  _inherits(K, _l);
  function K(e) {
    var _this;
    _classCallCheck(this, K);
    var r;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(K).call(this, e)), r = _assertThisInitialized(_assertThisInitialized(_this)), _this.minWidth = n(_this.props.type && (V[_this.props.type] ? V[_this.props.type] : 40)), _this.inputHeight = n(44), _this.checkEmptyError = function () {
      var _r$props = r.props,
        e = _r$props.required,
        t = _r$props.error,
        n = _r$props.type,
        a = _r$props.isOpen,
        o = r.state.value && 16 === r.state.value.length && "dinersClub" === r.state.cardType || r.state.value && 17 === r.state.value.length && "amex" === r.state.cardType || r.state.value && 19 === r.state.value.length || r.state.value && 20 === r.state.value.length && "unionPay" === r.state.cardType;
      !e || r.state.value && ("creditCard" !== n || o) || !0 === t || "calendar" === n || a || r.props.value ? r.setState({
        emptyError: !1
      }) : r.setState({
        emptyError: !0
      });
    }, _this._onClick = function (e) {
      var _r$props2 = r.props,
        t = _r$props2.onClickInlineAction,
        n = _r$props2.type,
        a = r.state.hidden;
      if (t && t(e), "password" === n) {
        var _e = "undefined" != typeof document && document.getElementById(r.inlineButtonWrapperId);
        _e && _e.setAttribute("aria-live", "assertive"), a ? (r.setState({
          hidden: !1
        }), setTimeout(function () {
          _e && _e.setAttribute("aria-live", "off"), r.setState({
            hidden: !0
          });
        }, 1e4)) : r.setState({
          hidden: !0
        });
      }
    }, _this._onKeyDown = function (e) {
      var _r$props3 = r.props,
        t = _r$props3.onClickInlineAction,
        n = _r$props3.type,
        a = r.state.hidden;
      if ((13 === e.keyCode || 32 === e.keyCode) && (t && t(e), "password" === n)) {
        var _e2 = "undefined" != typeof document && document.getElementById(r.inlineButtonWrapperId);
        _e2 && _e2.setAttribute("aria-live", "assertive"), a ? (r.setState({
          hidden: !1
        }), setTimeout(function () {
          _e2 && _e2.setAttribute("aria-live", "off"), r.setState({
            hidden: !0
          });
        }, 1e4)) : r.setState({
          hidden: !0
        });
      }
    }, _this._renderIcon = function (e) {
      var _r$props4 = r.props,
        n = _r$props4.type,
        a = _r$props4.mask,
        o = _r$props4.surface,
        i = "inlineAction" === n || "password" === n && r.state.value && r.state.value.length > 0 && "toggle" === a;
      return t(N, {
        tabIndex: -1,
        $renderPadding: i,
        "aria-hidden": "true",
        children: t(M, {
          tabIndex: -1,
          $iconSize: 20,
          $iconColor: "dark" === o ? c.elements.primary.ondark.value : c.elements.primary.onlight.value,
          "aria-hidden": !0,
          "aria-label": e ? "error icon" : "checkmark-alt icon",
          children: e ? E : D
        })
      });
    }, _this._renderInlineAction = function () {
      var _r$props5 = r.props,
        e = _r$props5.type,
        n = _r$props5.disabled,
        a = _r$props5.readOnly,
        o = _r$props5.surface,
        i = _r$props5.inlineActionButtonLabel,
        s = _r$props5.showPasswordButtonLabel,
        d = _r$props5.hidePasswordButtonLabel,
        l = _r$props5.showPasswordButton,
        u = _r$props5.hidePasswordButton;
      var c, p;
      return "password" === e ? r.state.hidden ? (c = l && l.label ? l.label : s, p = l && l.ariaLabel ? l.ariaLabel : "".concat(s, " password")) : (c = u && u.label ? u.label : d, p = u && u.ariaLabel ? u.ariaLabel : "".concat(d, " password")) : (c = i, p = i), t(f, {
        type: "standAlone",
        size: "large",
        viewport: "desktop",
        disabled: n || a,
        onClick: r._onClick,
        ariaLabel: p,
        onKeyDown: r._onKeyDown,
        surface: o,
        role: "button",
        children: c
      });
    }, _this._onPaste = function (e) {
      if ("tel" === r.props.type) {
        var _t = e.currentTarget;
        setTimeout(function () {
          _t.setSelectionRange(_t.value.length, _t.value.length);
        });
      }
      r.props.onPaste && r.props.onPaste(e);
    }, _this._onChange = function (e) {
      var _r$props6 = r.props,
        t = _r$props6.dateFormat,
        n = _r$props6.type,
        a = _r$props6.onChange,
        o = _r$props6.errorEvent,
        i = _r$props6.error,
        s = _r$props6.required,
        d = _r$props6.emptyError,
        l = r;
      var u;
      switch ("creditCard" !== n && a && a(e), !o || "change" !== o && "blurAndChange" !== o || b(e, l), n) {
        case "creditCard":
          return e.target.value = x(e), u = S(e, r.state.value), a && a(e, u.cardType), s && u.value && u.value.length > 0 && r.setState({
            emptyError: !1
          }), r.setState({
            value: u.value,
            cardType: u.cardType
          });
        case "tel":
          return u = I(e, r.state.value), s && u.value && u.value.length > 0 && r.setState({
            emptyError: !1
          }), r.setState({
            value: u.value
          });
        case "date":
          return e.target.value = x(e), u = T(e, r.state.value, t), s && u.value && u.value.length > 0 && r.setState({
            emptyError: !1
          }), r.setState({
            value: u.value
          });
        case "securityCode":
          e.target.value = w(e);
        default:
          return s && e.target.value.length > 0 && !d && r.setState({
            emptyError: !1
          }), !r.isControlled && r.setState({
            value: e.target.value
          });
      }
    }, _this.setHover = function () {
      r.setState(function (e) {
        return {
          hovered: !e.hovered
        };
      });
    }, _this._determineInputType = function () {
      var _r$props7 = r.props,
        e = _r$props7.type,
        t = _r$props7.readOnly,
        n = r.state.hidden;
      return "password" === e ? n || t ? "password" : "text" : "securityCode" === e ? "password" : "date" === e || "creditCard" === e || "inlineAction" === e ? "text" : "calendar" !== e ? e : void 0;
    }, _this._determineValue = function () {
      var _r$props8 = r.props,
        e = _r$props8.type,
        t = _r$props8.readOnly,
        n = _r$props8.value,
        a = _r$props8.defaultValue;
      return n || a ? "tel" === e || "securityCode" === e ? r.state.value : "creditCard" === e ? r.state.maskCC ? _(r.state.value, r.state.cardType) : r.state.value : n : "creditCard" === e && t || "creditCard" === e && r.state.maskCC ? _(r.state.value, r.state.cardType) : r.state.value;
    }, _this._renderStickyPlaceholder = function () {
      var _r$state = r.state,
        e = _r$state.value,
        n = _r$state.error,
        _r$props9 = r.props,
        a = _r$props9.disabled,
        o = _r$props9.dateFormat,
        i = _r$props9.success,
        s = _r$props9.surface;
      return t(q, {
        disabled: a,
        surface: s,
        children: P(o, e)
      });
    }, _this._onFocus = function (e) {
      var _r$props0 = r.props,
        t = _r$props0.type,
        n = _r$props0.readOnly,
        a = _r$props0.onFocus,
        _r$state2 = r.state,
        o = _r$state2.value,
        i = _r$state2.cardType;
      if (n) return;
      a && a(e);
      var s = "creditCard" === t && (o && 16 === o.length && "dinersClub" === i || o && 17 === o.length && "amex" === i || o && 19 === o.length);
      n || (s && r.setState({
        value: "",
        cardType: "placeholder",
        maskCC: !1
      }), r.setState({
        focused: !0
      }));
    }, _this._onBlur = function (e) {
      var _r$props1 = r.props,
        t = _r$props1.type,
        n = _r$props1.readOnly,
        a = _r$props1.errorEvent,
        s = _r$props1.error,
        d = _r$props1.required,
        l = _r$props1.isOpen,
        u = _r$props1.onBlur,
        c = _r$props1.emptyError,
        _r$state3 = r.state,
        p = _r$state3.value,
        h = _r$state3.cardType;
      if (n) return;
      var v = r;
      u && u(e);
      var f = p && 16 === p.length && "dinersClub" === h || p && 17 === p.length && "amex" === h || p && 19 === p.length || p && 20 === p.length && "unionPay" === h;
      n || ("creditCard" === t && f && r.setState({
        maskCC: !0
      }), r.setState({
        focused: !1,
        keyboardFocused: !1
      })), "blur" !== a && "blurAndChange" !== a || b(e, v), r.checkEmptyError(), "creditCard" === t && e.target.setCustomValidity(f ? "" : " "), "ios" === o() && "chrome" === i() && e.target.blur();
    }, _this._renderHelperText = function () {
      var _r$props10 = r.props,
        e = _r$props10.helperText,
        n = _r$props10.helperTextPlacement,
        a = _r$props10.disabled,
        o = _r$props10.surface;
      return t(g, {
        helperText: e,
        helperTextPlacement: n,
        disabled: a,
        surface: o
      });
    }, _this.state = {
      cardType: "placeholder",
      value: _this.props.value ? _this.props.value : _this.props.defaultValue ? _this.props.defaultValue : "",
      hidden: !0,
      focused: !1,
      hovered: !1,
      formattedValue: "",
      maskCC: !1,
      error: "function" != typeof _this.props.error && _this.props.error,
      emptyError: _this.props.emptyError,
      keyboardFocused: !1
    };
    return _this;
  }
  _createClass(K, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e = this;
      if (this.isControlled = void 0 !== this.props.value, "tel" === this.props.type) {
        var _e3 = this.props.value || this.props.defaultValue ? B(this.props.value || this.props.defaultValue) : "";
        this.setState({
          value: _e3
        });
      }
      var t = this.props.value || this.props.defaultValue;
      if ("creditCard" === this.props.type && t) {
        var _e4 = t.replace(/\D/g, ""),
          _L = L(void 0, _e4),
          _r = _L.cardType,
          _n = 16 === t.length && "dinersClub" === _r || 17 === t.length && "amex" === _r || 19 === t.length || 20 === t.length && "unionPay" === _r;
        this.setState({
          cardType: this.props.cardType ? this.props.cardType : _r,
          maskCC: _n
        });
      }
      this.isMobileDevice = s(), this.isAndroidDevice = "android" === o(), this.isAppleDevice = "osx" === o() || "ios" === o(), this.inlineButtonWrapperId = "inlineButtonWrapper-".concat(d()), document.addEventListener("keydown", function (t) {
        "Tab" === t.key && e.setState({
          keyboardFocused: !0
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e, t) {
      var _this$props = this.props,
        r = _this$props.emptyError,
        n = _this$props.required,
        a = _this$props.value,
        o = _this$props.error,
        i = _this$props.type;
      e.value !== a && this.isControlled && this.setState({
        value: a
      }), void 0 !== a && void 0 !== e.value && e.value !== a && this.checkEmptyError(), "boolean" == typeof o && e.error !== o && this.setState({
        error: o
      }), "calendar" !== i && void 0 === o && (e.emptyError !== r && this.setState({
        emptyError: r
      }), e.required !== this.props.required && this.setState({
        emptyError: !1
      })), "calendar" !== i && (e.required === this.props.required || this.props.required || this.setState({
        emptyError: !1
      })), "calendar" === i && (e.emptyError !== r && this.setState({
        emptyError: r
      }), (e.required !== this.props.required || e.value !== this.props.value && this.props.value) && this.setState({
        emptyError: !1
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var a = this;
      var o = this.props,
        i = o.value,
        s = o.readOnly,
        l = o.error,
        u = o.label,
        c = o.errorText,
        p = o.disabled,
        h = o.width,
        f = o.isOpen,
        m = o.ariaLabel,
        y = o.required,
        b = o.id,
        g = o.type,
        w = o.dateFormat,
        x = o.tooltip,
        T = o.tooltipTitle,
        I = o.tooltipContent,
        S = o.tooltipCloseButtonText,
        _ = o.helperTextPlacement,
        P = o.helperText,
        B = o.success,
        L = o.successText,
        E = o.cardType,
        D = o.onClickInlineAction,
        V = o.maxLength,
        q = o.inputId,
        N = o.mask,
        M = o.renderInputIcon,
        K = o.surface,
        R = o.caretColor,
        U = o.transparentBackground,
        Y = o.onClick,
        J = o.autoComplete,
        Q = o.containsPii,
        ee = o.calculateInputPadding,
        te = o.hidePasswordButtonLabel,
        re = o.inlineActionButtonLabel,
        ne = o.showPasswordButtonLabel,
        ae = o.errorEvent,
        oe = e(o, ["value", "readOnly", "error", "label", "errorText", "disabled", "width", "isOpen", "ariaLabel", "required", "id", "type", "dateFormat", "tooltip", "tooltipTitle", "tooltipContent", "tooltipCloseButtonText", "helperTextPlacement", "helperText", "success", "successText", "cardType", "onClickInlineAction", "maxLength", "inputId", "mask", "renderInputIcon", "surface", "caretColor", "transparentBackground", "onClick", "autoComplete", "containsPii", "calculateInputPadding", "hidePasswordButtonLabel", "inlineActionButtonLabel", "showPasswordButtonLabel", "errorEvent"]),
        _this$state = this.state,
        ie = _this$state.cardType,
        se = _this$state.focused,
        de = _this$state.error,
        le = _this$state.emptyError,
        ue = le || de || "boolean" == typeof l && l,
        ce = q || d(),
        pe = (ue || B) && !se && !s && !p,
        he = this.state.value && this.state.value.length > 0 && "toggle" === N,
        ve = ("inlineAction" === g || "password" === g && he) && !s,
        fe = "".concat(ce, "-label"),
        me = u || "";
      var ye = m || ("date" === g ? function () {
          if ("date" === g) switch (w) {
            case "mmyy":
              return "".concat(u, " input, please enter two digits for the month and two digits for the year");
            case "mmddyy":
              return "".concat(u, " input, please enter two digits for the month, two digits for the day and two digits for the year");
            case "mmddyyyy":
              return "".concat(u, " input, please enter two digits for the month, two digits for the day and four digits for the year");
            default:
              return;
          }
        }() : y ? me : "".concat(me, " Optional Input Field")),
        be = c || (le ? "You must enter a ".concat(me.toLowerCase()) : "");
      ue && !be && console.error("Error Text for Input MUST be provided");
      var ge = function ge() {
        var e;
        if (e = ue && be ? P ? "".concat(ye, " ").concat(be, " ").concat(P) : "".concat(ye, " ").concat(be) : P ? "".concat(ye, " ").concat(P) : ye, "calendar" === g) {
          var _t2 = a.isMobileDevice ? "Double tap to expand calendar" : "Press space/enter to expand calendar";
          e = "".concat(e, " ").concat(f ? "expanded" : a.props.value ? "selected date ".concat(a.props.value, " collapsed. ").concat(_t2) : "collapsed. ".concat(_t2));
        }
        return e;
      };
      return t(O, {
        $helperTextPlacement: _,
        $minWidth: this.minWidth,
        $containerWidth: h,
        onMouseEnter: this.setHover,
        onMouseLeave: this.setHover,
        children: r(F, {
          id: b,
          "data-testid": "test-container",
          children: [u && t(k, {
            disabled: p,
            required: y,
            label: u,
            tooltip: x,
            tooltipTitle: T,
            tooltipContent: I,
            tooltipCloseButtonText: S,
            type: g,
            "data-testid": "test-label",
            id: fe,
            "aria-label": u,
            htmlFor: "calendar" === g && this.isAppleDevice ? void 0 : ce,
            cardType: E,
            helperTextPlacement: _,
            helperText: P,
            CreditCardIcon: C,
            surface: K
          }), r(Z, {
            children: [r(X, {
              $helperText: P,
              $helperTextPlacement: _,
              "aria-live": "calendar" === g && this.isMobileDevice || this.isAppleDevice ? void 0 : "assertive",
              children: [M && M(), r(W, {
                $transparentBackground: U,
                $hovered: this.state.hovered,
                $keyboardFocused: this.state.keyboardFocused,
                $minWidth: this.minWidth,
                $error: ue,
                disabled: p,
                $isOpen: f,
                $inputHeight: this.inputHeight,
                $success: B,
                readOnly: s,
                surface: K,
                $focused: this.state.focused,
                children: ["creditCard" === g && ie && t(G, {
                  children: t(C, {
                    surface: K,
                    name: ie
                  })
                }), r(j, {
                  "aria-live": "calendar" === g && f ? "assertive" : "off",
                  onClick: "calendar" === g && this.isAndroidDevice && Y ? function () {
                    return Y();
                  } : void 0,
                  tabIndex: "calendar" === g && this.isAndroidDevice ? -1 : void 0,
                  "aria-label": "calendar" === g && this.isAndroidDevice ? ge() : void 0,
                  children: [t(z, Object.assign({
                    ref: this.props.inputRef,
                    className: Q ? "contains-PII" : void 0,
                    $hidePasswordButtonLabel: te,
                    $inlineActionButtonLabel: re,
                    $showPasswordButtonLabel: ne,
                    $errorEvent: ae,
                    maxLength: A(this.state.cardType, g, w, E, V),
                    "data-testid": "test-input",
                    "aria-label": ge(),
                    id: ce,
                    autoComplete: J || "off",
                    inputMode: "creditCard" === g ? "numeric" : void 0,
                    $calculateInputPadding: ee
                  }, oe, {
                    placeholder: void 0,
                    onClick: "calendar" === g && this.isAndroidDevice ? void 0 : Y,
                    disabled: p,
                    required: y,
                    "aria-invalid": !1,
                    readOnly: s,
                    surface: K,
                    onChange: this._onChange,
                    onPaste: this._onPaste,
                    value: "password" === g || "securityCode" === g ? this.props.value : this._determineValue(),
                    $masked: "password" === this._determineInputType() && this.state.hidden,
                    type: this._determineInputType(),
                    caretColor: R,
                    "aria-hidden": "calendar" === g && this.isAndroidDevice,
                    onFocus: this._onFocus,
                    onBlur: this._onBlur
                  })), "date" === g && this._renderStickyPlaceholder()]
                }), (pe || ve) && r(H, Object.assign({
                  id: this.inlineButtonWrapperId
                }, ve && "password" === g ? {
                  "aria-live": "off",
                  "aria-relevant": "additions"
                } : {}, {
                  children: [pe && this._renderIcon(ue), ve && this._renderInlineAction()]
                }))]
              }), (ue && be || B && L) && !p && !s && t($, {
                errorText: be,
                error: ue,
                success: B,
                successText: L,
                surface: K,
                errorLabelSpacing: n(v.space["2X"].value)
              })]
            }), P && "right" === _ && this._renderHelperText()]
          }), P && "bottom" === _ && this._renderHelperText()]
        })
      });
    }
  }]);
  return K;
}(l);
K.defaultProps = {
  transparentBackground: !1,
  error: void 0,
  errorEvent: "blur",
  label: void 0,
  mask: "toggle",
  dateFormat: "mmddyyyy",
  isOpen: !1,
  calculateInputPadding: function calculateInputPadding() {
    return n(parseInt(h.space.inset.value, 10) - 1);
  },
  type: void 0,
  surface: "light",
  inlineActionButtonLabel: "Apply",
  showPasswordButtonLabel: "Show",
  hidePasswordButtonLabel: "Hide",
  containsPii: !1,
  required: !0
};
var R = a(K);
export { R as default };